export default ['api', function (api) {
    return {
        getDetails: offerId => {
            return api.get(`offers/${offerId}`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/availability/services/offer.api.service.js